export default __webpack_public_path__ + "static/media/noa-11.a992bfbb.jpg";